<script setup lang="ts">
import { defineEmits, defineProps } from "vue";

defineProps<{
  show: boolean;
  reason: string | null;
}>();

const emit = defineEmits<{
  close: [];
}>();
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div class="bg-white space-y-6 rounded-lg shadow-lg p-6 max-w-md w-full">
      <div>
        <h2 class="text-xl font-semibold mb-2">Task Completion Blocked</h2>
        <p class="text-gray-700">
          {{ reason || "Completion requirements are not met." }}
        </p>
      </div>

      <div class="flex justify-end">
        <button
          class="bg-primary hover:bg-primary/80 transition-all text-white px-4 py-1 rounded"
          @click="emit('close')"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>
